<template>
<div class="about">
      <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
        <template v-slot:activator="{ on }">
          <v-icon color="blue" v-on="on">today</v-icon>
        </template>
        <v-date-picker color="blue" locale="PT-br" ref="pickerEnd" v-model="date" :min="new Date(dataMinima).toISOString().substr(0, 10)" :max="new Date().toISOString().substr(0, 10)" @change="save"></v-date-picker>
      </v-menu>
</div>
</template>

<script>

export default {
  name: 'dateForm',
  props: {
    dataMaxima: String,
    dataMinima: String
  },
  data () {
    return {
      dateFormatted: '',
      date: null,
      dateDias: [],
      menu: false,
      menuEnd: false,
      maxDate: '',
      minDate: '',
      dateFormattedEnd: '',
      dateEnd: null,
      erroDate: '',
      load: false
    }
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    date (val) {
      this.save(val)
      // this.dateEnd = null
      // this.dateFormatted = this.formatDate(this.date)
      // this.corrigirDataMinima()
    },
    menuEnd (val) {
      val && setTimeout(() => (this.$refs.pickerEnd.activePicker = 'YEAR'))
    }
  },
  methods: {
    save (date) {
      this.$refs.menu.save(date)
      this.$emit('date', date)
    },
    saveEnd (date) {
      this.$refs.menuEnd.save(date)
      this.$emit('dataFim', date)
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}
</script>
